import { AfterViewInit, Component, OnDestroy, OnInit, Input, Output, EventEmitter, inject } from "@angular/core";
import { of, Subscription } from 'rxjs';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AppQueries, Dispatcher } from 'src/app/state';
import { ActivatedRoute } from "@angular/router";
import { EditComponent } from "../edit.component";
import { Constant } from "../../../core/constant";
import { EventManager } from "../../../core";
import { ShortcutService } from "../../../core/services/shortcut.service";
import { NZ_MODAL_DATA, NzModalRef } from "ng-zorro-antd/modal";
/**
 * declare Jquery
 * */
declare let $: any;

@Component({
    selector: 'otp',
    templateUrl: "./otp.component.html",
    styleUrls: ["./otp.component.scss"]
})

export class OTPComponent extends EditComponent implements OnInit, OnDestroy {
    @Output() result: EventEmitter<any> = new EventEmitter();
    @Input() data: any = {};
    email: any;
    startTime: any;
    defaultTime = 5 * 60;
    otp: string = '';
    isCall: boolean = false;
    isSmartOTP: boolean = false;
    failTimes = 0;
    countdown = 10;
    myInterval: any;
    accountInfo: any;
    theme: any;
    subscription: Subscription[] = [];
    Constant = Constant;
    isInvalidOTP: boolean = false;
    errorText: string = '';
    readonly nzModalData: any = inject(NZ_MODAL_DATA);
    constructor(
        public eventManger: EventManager,
        private modalRef : NzModalRef,
        public route: ActivatedRoute,
        private appQueries: AppQueries
    ) {
        super(eventManger, route);
    }
    ngOnInit() {
        this.data = this.nzModalData.data;
        ShortcutService.addOneKey(13, this.confirm.bind(this));
        this.subscription = [
            this.eventManger.subscribe('set-data-otp', (res) => {
                this.data = res.content.data || this.data;
                this.otp = '';
                this.startTime = Date.now();
                this.countdown = Math.floor((this.startTime + this.defaultTime * 1000 - Date.now()) / 1000);
                ShortcutService.addOneKey(13, this.save.bind(this));
            }),
            this.eventManger.subscribe('close-modal', (res) => { this.dismiss() }),
            this.eventManger.subscribe('invalid-otp', (res) => { this.invalidOTP(res.content); }),
            this.appQueries.userProfile$
            .subscribe((userProfile) => {
                this.accountInfo = userProfile || {};
                this.email = this.accountInfo.email;
            }),
        ];
        this.startTime = this.startTime || Date.now();
        this.countdown = Math.floor((this.startTime + this.defaultTime * 1000 - Date.now()) / 1000);
        this.isSmartOTP = (this.data || {}).isSmartOtp;
        this.myInterval = setInterval(() => {
            if (!this.isSmartOTP && this.countdown > 0) {
                this.countdown--;
            }
        }, 1000);
        super.ngOnInit();
    }
    ngOnDestroy() {
        this.eventManger.destroys(this.subscription);
        clearInterval(this.myInterval);
        this.eventManger.broadcast({
            name: 'action-destroy-otp',
            content: {
                countdown: this.countdown,
                date: Date.now()
            }
        })
    }
    dismiss() {
        ShortcutService.removeFuncEsc();
        this.modalRef.close();
    }
    validate() {
        return this.otp && (this.otp + '').length === 6 && this.countdown != 0;
    }
    confirm() {
        if (!this.validate()) {
            return of(false);
        }
        const data = Object.assign({}, this.data || {});
        data.otp = this.otp + '';
        this.result.emit(data);
        this.isInvalidOTP = false;
        this.executeFunction();
    }
    executeFunction() {
        const data = Object.assign({}, this.data || {});
        data.otp = this.otp + '';
        if (this.isCall) {
            return;
        }
        this.isCall = true;
        this.eventManger.broadcast({
            name: 'result-otp',
            content: data,
        });
    }
    invalidOTP(error) {
        this.otp = '';
        this.isInvalidOTP = true;
        this.isCall = false;
        this.errorText = error.message;
    }
    cancel() {
        this.result.emit(null);
    }
    resendOTP() {
        this.eventManger.broadcast({
            name: 'resend-otp',
        });
    }
    reset() {
        this.startTime = Date.now();
        this.countdown = Math.floor((this.startTime + this.defaultTime * 1000 - Date.now()) / 1000);
    }
}
